export namespace StringUtils {

  export const EMPTY = '';

  /**
   * Check whether input string is JSON format or not.
   *
   * @export
   * @param {string} str
   * @return {*}  {boolean}
   */
  export function isJSON(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  /**
   * Check whether input string is null / undefined / empty string or not.
   *
   * @export
   * @param {(string | null | undefined)} str
   * @return {*}  {boolean}
   */
  export function isEmpty(str: string | null | undefined): boolean {
    return str === null || str === undefined || str === EMPTY;
  }
}
